import AdvancedController from "../lib/advanced-controller"
import { gsap } from 'gsap';
// import ScrollTrigger from "gsap/ScrollTrigger";

// gsap.registerPlugin(ScrollTrigger);

export default class Scene04Controller extends AdvancedController {

  static targets = [
    "container",
    "industry",
    "bgImage",
    // "row",
    "wrapper"
  ];

  static values = {
  }

  connect() {
    super.connect();

    const BASE_ANIMATION_TIME = 1;

    this.timeline = gsap.timeline({

      onUpdate: this.onUpdate.bind(this),
      scrollTrigger: {
        // trigger: this.containerTarget,
        start: "-64px top",
        pin: this.containerTarget,
        end: "1400%",
        scrub: 0.5,
        // markers: { startColor: "green", endColor: "red", fontSize: "12px" }
      }
    });

    const wrapperXEase = 'none'
    const textInEase = 'none'
    const textOutEase = 'none'
    // const wrapperXEase = 'power2.inOut'
    // const textInEase = 'power2.out'
    // const textOutEase = 'power2.in'

    this.timeline
      .set(this.wrapperTarget, { x: '100vw' })
      // ---
      // .to(document.body, { opacity: 1, ease: 'none', duration: 0.5 * BASE_ANIMATION_TIME })
      // SCENE 1
      .to(this.wrapperTarget, { x: '0vw', ease: wrapperXEase, duration: BASE_ANIMATION_TIME })
      .to(this.industryTargets[0], { filter: 'blur(0px)', ease: textInEase, duration: BASE_ANIMATION_TIME }, "<")
      .to(this.bgImageTargets[0], { opacity: 1, ease: 'none', duration: 0.25 * BASE_ANIMATION_TIME }, "<25%")
      // --- break
      .to(document.body, { opacity: 1, ease: 'none', duration: 0.5 * BASE_ANIMATION_TIME })
      // SCENE 2
      // --- move the wrapper to the left (one screen width)
      .to(this.wrapperTarget, { x: '-100vw', ease: wrapperXEase, duration: BASE_ANIMATION_TIME })
      // --- in parallel blur the last industry text
      .to(this.industryTargets[0], { filter: 'blur(0px)', ease: textOutEase, duration: BASE_ANIMATION_TIME }, "<")
      // --- in parallel remove the blur from the current industry text
      .to(this.industryTargets[1], { filter: 'blur(0px)', ease: textInEase, duration: BASE_ANIMATION_TIME }, "<")
      // --- with a slight delay (<25%) fade in the background image
      .to(this.bgImageTargets[0], { opacity: 0, display: 'none', ease: 'none', duration: 0.25 * BASE_ANIMATION_TIME }, "<")
      .to(this.bgImageTargets[1], { opacity: 1, ease: 'none', duration: 0.25 * BASE_ANIMATION_TIME }, "<25%")
      // --- break
      .to(document.body, { opacity: 1, ease: 'none', duration: 0.5 * BASE_ANIMATION_TIME })
      // SCENE 3
      .to(this.wrapperTarget, { x: '-200vw', ease: wrapperXEase, duration: BASE_ANIMATION_TIME })
      .to(this.industryTargets[1], { filter: 'blur(0px)', ease: textOutEase, duration: BASE_ANIMATION_TIME }, "<")
      .to(this.industryTargets[2], { filter: 'blur(0px)', ease: textInEase, duration: BASE_ANIMATION_TIME }, "<")
      .to(this.bgImageTargets[1], { opacity: 0, display: 'none', ease: 'none', duration: 0.25 * BASE_ANIMATION_TIME }, "<")
      .to(this.bgImageTargets[2], { opacity: 1, ease: 'none', duration: 0.25 * BASE_ANIMATION_TIME }, "<25%")
      // --- break
      .to(document.body, { opacity: 1, ease: 'none', duration: 0.5 * BASE_ANIMATION_TIME })
      // SCENE 4
      .to(this.wrapperTarget, { x: '-300vw', ease: wrapperXEase, duration: BASE_ANIMATION_TIME })
      .to(this.industryTargets[2], { filter: 'blur(0px)', ease: textOutEase, duration: BASE_ANIMATION_TIME }, "<")
      .to(this.industryTargets[3], { filter: 'blur(0px)', ease: textInEase, duration: BASE_ANIMATION_TIME }, "<")
      .to(this.bgImageTargets[2], { opacity: 0, display: 'none', ease: 'none', duration: 0.25 * BASE_ANIMATION_TIME }, "<")
      .to(this.bgImageTargets[3], { opacity: 1, ease: 'none', duration: 0.25 * BASE_ANIMATION_TIME }, "<25%")
      // --- break
      .to(document.body, { opacity: 1, ease: 'none', duration: 0.5 * BASE_ANIMATION_TIME })
      // SCENE 5
      .to(this.wrapperTarget, { x: '-400vw', ease: wrapperXEase, duration: BASE_ANIMATION_TIME })
      .to(this.industryTargets[3], { filter: 'blur(0px)', ease: textOutEase, duration: BASE_ANIMATION_TIME }, "<")
      .to(this.industryTargets[4], { filter: 'blur(0px)', ease: textInEase, duration: BASE_ANIMATION_TIME }, "<")
      .to(this.bgImageTargets[3], { opacity: 0, display: 'none', ease: 'none', duration: 0.25 * BASE_ANIMATION_TIME }, "<")
      .to(this.bgImageTargets[4], { opacity: 1, ease: 'none', duration: 0.25 * BASE_ANIMATION_TIME }, "<25%")
      // --- break
      .to(document.body, { opacity: 1, ease: 'none', duration: 0.5 * BASE_ANIMATION_TIME })
      // SCENE 6
      .to(this.wrapperTarget, { x: '-500vw', ease: wrapperXEase, duration: BASE_ANIMATION_TIME })
      .to(this.industryTargets[4], { filter: 'blur(0px)', ease: textOutEase, duration: BASE_ANIMATION_TIME }, "<")
      .to(this.industryTargets[5], { filter: 'blur(0px)', ease: textInEase, duration: BASE_ANIMATION_TIME }, "<")
      .to(this.bgImageTargets[4], { opacity: 0, display: 'none', ease: 'none', duration: 0.25 * BASE_ANIMATION_TIME }, "<")
      .to(this.bgImageTargets[5], { opacity: 1, ease: 'none', duration: 0.25 * BASE_ANIMATION_TIME }, "<25%")
      // 
      .to(document.body, { opacity: 1, ease: 'none', duration: 1 * BASE_ANIMATION_TIME })

  }

  onUpdate() {
    this.sendMessage(this.debugController, 'messageProgress', this.timeline.progress())
  }

  messageDebugInit(debugController) {
    this.debugController = debugController
    this.hasDebugController = true
  }

  messageProgress(progress) {
    this.timeline.pause();
    this.timeline.progress(progress)
  }

  messageTogglePlayPause() {
    if (this.timeline.paused()) {
      this.timeline.play();
    } else {
      this.timeline.pause();
    }
  }

}
